import {postRequest} from "./postRequest";

export const getAssetsOfContract = (id: number) => {
    return postRequest('/api/contracts/getAssetsOfContract', {
        id,
    })
}